import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { Hotspots } from 'app/views';
import { IRootState } from 'app/reducers/AppState';
import { IHotspotsModel, IRegion, IVehicleTypeListModel, IHotspotModel } from 'app/models';
import { fetchVehiclesTypesList, editHotspot, fetchHotspots } from 'app/actions';

interface StateFromProps {
  hotspots: IHotspotsModel;
  selectedRegion: IRegion | null;
  vehicleTypesList: IVehicleTypeListModel[];
}

interface DispatchFromProps {
  fetchHotspots: () => void;
  fetchVehicleTypesList: () => void;
  handleEditHotSpot: (hotspot: IHotspotModel) => void;
}

const mapStateToProps = (state: IRootState): StateFromProps => ({
  hotspots: state.hotspots,
  selectedRegion: state.userDetails.selectedRegion,
  vehicleTypesList: state.vehicleTypes.vehicleTypesList,
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchFromProps => ({
  fetchHotspots: bindActionCreators(fetchHotspots, dispatch),
  fetchVehicleTypesList: bindActionCreators(fetchVehiclesTypesList, dispatch),
  handleEditHotSpot: bindActionCreators(editHotspot, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Hotspots);
